<mat-toolbar class="bg-red mat-elevation-z4">
  <a href="">
    <img src="./../../../../assets/header/food.jpg" alt="logo - uai" width="100">
  </a>
  <span class="title">
    Uai<span class="color-pink">Food</span>
  </span>
  <span class="example-spacer"></span>
  <a href="https://api.whatsapp.com/send?phone=31999079989">
    <button class="atendimento" mat-raised-button>
      <i class="fab fa-whatsapp"></i>
      <span>Atendimento Online</span>
    </button>
  </a>
</mat-toolbar>
